import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

function VendorInformation(props) {
  return (
    <div className="w-100">
      <h2 className="w-100 f4 f3-ns mb3 fw4">Vendor Information</h2>
      <div className="w-100 gcc-box-1 mb4">
        <div className="flex flex-wrap flex-nowrap-l f6 pv3 pv0-l">
          <div className="ph3 ph0-l w-100 w-60-l mb3 mb0-l">
            <dl className="lh-title flex w-100  flex-wrap ">
              <dt data-type="label-value" className="pa3-l near-black bb-l b--mid-gray b w-100">Order ID</dt>
              <dd className="pa3-l near-black w-100"><a className="link pointer underline blue hover-orange" href={props.mandiOrderDetailsUrl}>{props.orderNumber}</a></dd>
            </dl>
          </div>
          <div className="ph3 ph0-l w-100 w-50-l mb3 mb0-l">
            <dl className="lh-title flex w-100  flex-wrap ">
              <dt data-type="label-value" className="pa3-l near-black bb-l b--mid-gray b w-100">Windows</dt>
              <dd className="pa3-l near-black w-100">{props.numberOfWindows}</dd>
            </dl>
          </div>
          <div className="ph3 ph0-l w-100 mb3 mb0-l">
            <dl className="lh-title flex w-100  flex-wrap ">
              <dt data-type="label-value" className="pa3-l near-black bb-l b--mid-gray b w-100">Date</dt>
              <dd className="pa3-l near-black w-100">
                {format(props.orderDate, 'MMMM DD, YYYY')}
              </dd>
            </dl>
          </div>
          <div className="ph3 ph0-l w-100 mb3 mb0-l">
            <dl className="lh-title flex w-100  flex-wrap ">
              <dt data-type="label-value" className="pa3-l near-black bb-l b--mid-gray b w-100">Service Provider</dt>
              <dd className="pa3-l near-black w-100">{props.serviceProvider}</dd>
            </dl>
          </div>
          <div className="ph3 ph0-l w-100 mb3 mb0-l">
            <dl className="lh-title flex w-100  flex-wrap ">
              <dt data-type="label-value" className="pa3-l near-black bb-l b--mid-gray b w-100">Technicians</dt>
              <dd className="pa3-l near-black w-100">{props.technicians}</dd>
            </dl>
          </div>
          <div className="ph3 ph0-l w-100 mb3 mb0-l">
            <dl className="lh-title flex w-100  flex-wrap ">
              <dt data-type="label-value" className="pa3-l near-black bb-l b--mid-gray b w-100">Phone</dt>
              <dd className="pa3-l near-black w-100"><a href={`tel:${props.serviceProviderPhone}`}>{props.serviceProviderPhone}</a></dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}

VendorInformation.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  numberOfWindows: PropTypes.string.isRequired,
  orderDate: PropTypes.string.isRequired,
  serviceProvider: PropTypes.string.isRequired,
  technicians: PropTypes.arrayOf(PropTypes.string).isRequired,
  serviceProviderPhone: PropTypes.string.isRequired,
  mandiOrderDetailsUrl: PropTypes.string.isRequired,
};

export default VendorInformation;
